<template>
  <div>
    <section class="officer-open-recruitment-post-list ly-list">
      <div class="section-inner">
        <div class="section-cont">
          <h2>사관 &middot; 공채 공고 관리</h2>
          <p class="site-path">
            <span>Home</span>&nbsp;&gt;&nbsp;
            <span>EDUCATION</span>&nbsp;&gt;&nbsp;
            <span>사관 &middot; 공채 공고 관리</span>
          </p>
          <!-- /.site-path -->
          <p class="total-post">전체 게시물 <span>{{ getDataTotalCount }}</span>개</p>
          <!-- /.total-post -->
          <search-input :searchHandler="onSearch" />
          <!-- /.search -->
          <table>
            <colgroup>  
              <col class="col1" />
              <col class="col2" />
              <col class="col3" />
              <col class="col4" />
              <col class="col5" />
            </colgroup>
            <thead>
              <tr>
                <th scope="col" class="check-cell">
                  <label for="" class="hidden">전체체크</label>
                  <input
                    type="checkbox"
                    @click="check()"
                    v-model="checkAllValue"
                  />
                  <div class="chk-icon-wrap">
                    <img
                      class="chk-icon"
                      src="@/assets/image/icon-form-checkbox.jpg"
                      alt="icon checkbox"
                    />
                  </div>
                </th>
                <th scope="col">No.</th>
                <th scope="col">게시물 제목</th>
                <th scope="col">마감일</th>
                <th scope="col">등록일</th>
              </tr>
            </thead>
            <tbody>


              <tr v-for="item in getData" v-bind:key="item.id">
                <td class="check-cell">
                  <label for="" class="hidden">사진 및 졸업동영상 체크</label>
                  <input
                    type="checkbox"
                    v-model="checkedValues"
                    :value="item.id"
                  />
                  <div class="chk-icon-wrap">
                    <img
                      class="chk-icon"
                      src="@/assets/image/icon-form-checkbox.jpg"
                      alt="icon checkbox"
                    />
                  </div>
                </td>
                <td>{{item.id}}</td>
                <td class="left board-title-cell">
                  <router-link
                    :to="{ name: 'OfficerOpenRecruitmentPostEdit' , params: { id: item.id, item: item } }"
                    class="of-hidden board-title"
                  >
                    {{item.title}}
                  </router-link>

                  <div v-show="isClosing(item.due_date)">
                    <router-link
                      :to="{ name: 'OfficerOpenRecruitmentPostEdit' , params: { id: item.id, item: item } }"
                      class="badge"
                    >
                      마감
                    </router-link>
                  </div>
                </td>
                <td>{{item.due_date}}</td>
                <td>
                    {{ $moment(item.created_dttm).format("YYYY.MM.DD") }}
                </td>
              </tr>

            </tbody>
          </table>
          <!-- /.table-->
          <div class="page">
            <paginate
              :pageCount="totalPages"
              :pageRange="10"
              :clickHandler="handlePageSelected"
            ></paginate>
          </div>
          <!-- /.paginate -->
          <div class="btn-wrap">
            <button class="btn-icon-del" @click="onConfirmDelete">
              <img src="../../../assets/image/btn-del.png" alt="delete icon" />
              <span>선택삭제</span>
            </button>
            <router-link
              :to="{ name: 'OfficerOpenRecruitmentPostCreate' }"
              class="btn-blue" 
              >등록</router-link
            >
          </div>
          <!-- /.btn-wrap -->
        </div>

        <app-footer />
      </div>
    </section>
  </div>
</template>

<script>
import AppFooter from "../../AppFooter.vue";
import Paginate from "../../Paginate.vue";
import SearchInput from "../../SearchInput.vue";

export default {
  components: { AppFooter, Paginate, SearchInput },

  name: "OfficerOpenRecruitmentPostList",
  data() {
    return {
      data_list: [ ] ,
      data_total_count: 0 ,
    };
  },
  computed: {
    getData: function() {
      return this.data_list ; 
    },
    getDataTotalCount: function() {
      return this.data_total_count ; 
    },
  },
  created() {
    this.loadData({
      page: 1,
      size: this.PAGE_SIZE,
    }) ;
  },   
  methods: {
    isClosing(due_date) {
      var currentDate = new Date();
      var dueDate     = new Date(due_date) ;
      dueDate.setDate(dueDate.getDate() + 1)

      if( dueDate > currentDate ) {
        // 마감일 지나지 않음.
        return false ;
      } else {
        // 마감 지남
        return true ;
      }
    },
    loadData( payload ) {
      this.$store.dispatch("education/req_officeropenrecruitment_announce_list", payload ).then( result => {
        console.log( 'req_officeropenrecruitment_announce_list result => ', result );
        this.data_list = result.data ; 
        this.data_total_count = result.total_count  ; 
      }).catch( err => { 
        console.log( ' error => ', err );
      });
    },
    onSearch(text) {
      this.loadData( {
        page: 1,
        size: this.PAGE_SIZE,
        searchtext: text,
      }); 
    },
    handlePageSelected(page) {
      console.log("handlePageSelected => ", page);
      this.loadData( {
        page: page,
        size: this.PAGE_SIZE,
      }); 
    },
    onSubmitDelete()  {
      console.log("onSubmitDelete ==> ", this.checkedValues);
      if (this.checkedValues.length > 0) {        
        this.$store.dispatch("education/req_remove_officeropenrecruitment_announce_list", {
          idarr: this.checkedValues,
        }).then( (result) => {
          this.checkedValues = [];
          this.data_list = result.data ; 
          this.data_total_count = result.total_count  ; 
        });

      }
    },


  },
};
</script>


<style lang="scss" scoped>
table {
  .col1 {
    width: 64px;
  }
  .col2 {
    width: 91px;
  }
  .col4 {
    width: 180px;
  }
  .col5 {
    width: 180px;
  }
  .board-title-cell {
    display: flex;
    align-items: center;
  }
  .board-title {
    display: inline-block !important;
    width: auto !important;
    max-width: calc(100% - 100px);
  }
  .badge {
    width: auto !important;
    display: inline-block !important;
    width: 60px !important;
    height: 36px !important;
    line-height: 36px;
    text-align: center;
    padding: 0 !important;
    background-color: #e5e7eb;

    font-size: 16px;
  }
}
</style>
